/**
 * This class represents the result of a validator
 */
export default class ValidationResult {
    /**
     * @type {ValidatorInterface}
     */
    validator = null;

    /**
     * @type {AbstractItem[]}
     */
    items = [];

    /**
     * @type {AbstractProblem[]}
     */
    problems = [];

    /**
     * @param {ValidatorInterface} validator
     * @param {AbstractItem[]} items
     * @param {AbstractProblem[]} problems
     */
    constructor(validator, items = [], problems = []) {
        this.validator = validator;
        this.items = items;
        this.problems = problems;
    }
}
